export const getStyled = (theme) => ({
  dialogPaper: {
    backgroundColor: theme.palette.mode === 'light' ? '#ffff' : '#192734',
  },

  menuPaper: {
    backgroundColor: theme.palette.mode === 'light' ? '#ffff' : '#192734',
  },

  buttonOk: {
    backgroundColor: '#4CAF50',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#388e3c',
    },
  },

  buttonCancel: {
    backgroundColor: '#FF5F1F',
    borderColor: '#FF5F1F',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#ff7139',
      borderColor: '#ff7139',
    },
  },

  online: {
    fontSize: 11,
    color: '#25d366',
  },
  offline: {
    fontSize: 11,
    color: '#e1306c',
  },
});
